module.exports = __webpack_public_path__ + "img/firebase.3f72504d.svg";